import type { FC } from 'react';
import React from 'react';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { BackgroundColor, BorderColor, Props } from './types';

const getMessageStyles = (backgroundColor?: BackgroundColor, borderColor?: BorderColor) => {
    const colorStylesMap = {
        blue: {
            background: blueBackgroundStyles,
            border: blueBorderStyles,
        },
        grey: {
            background: greyBackgroundStyles,
            border: greyBorderStyles,
        },
    };

    return [
        baseStyles,
        backgroundColor && colorStylesMap[backgroundColor].background,
        borderColor && colorStylesMap[borderColor].border,
    ].filter(Boolean);
};

export const Message: FC<Props> = ({
    header,
    content,
    extraContent,
    actions,
    backgroundColor,
    borderColor,
    position,
}) => {
    return (
        <Inline grow="fill" alignInline={position === 'left' ? 'start' : 'end'}>
            <Box xcss={getMessageStyles(backgroundColor, borderColor)}>
                <Stack space="space.200">
                    {header}
                    {content}
                    {extraContent}
                    {actions}
                </Stack>
            </Box>
        </Inline>
    );
};

const baseStyles = xcss({
    paddingInline: 'space.200',
    paddingBlock: 'space.100',
    borderRadius: 'border.radius.200',
});

const blueBorderStyles = xcss({
    border: `2px solid ${token('color.border.accent.blue', '#0052CC')}`,
});

const greyBorderStyles = xcss({
    border: `2px solid ${token('color.border.accent.gray', '#DFE1E6')}`,
});

const blueBackgroundStyles = xcss({
    backgroundColor: 'color.background.accent.blue.subtlest',
});

const greyBackgroundStyles = xcss({
    backgroundColor: 'color.background.inverse.subtle',
});
